import { useState, useEffect } from 'react';
import { Move, MoveHorizontal, MoveVertical } from 'lucide-react';

export type MoveIconType = 'horizontal' | 'vertical' | 'move';

export const useResponsiveMoveIcon = (iconType: 'auto' | MoveIconType = 'auto') => {
  const [currentIcon, setCurrentIcon] = useState<typeof Move>(Move);
  const [currentTitle, setCurrentTitle] = useState('Drag to reorder');

  useEffect(() => {
    if (iconType !== 'auto') {
      // Static icon type
      switch (iconType) {
        case 'horizontal':
          setCurrentIcon(MoveHorizontal);
          setCurrentTitle('Drag to reorder horizontally');
          break;
        case 'vertical':
          setCurrentIcon(MoveVertical);
          setCurrentTitle('Drag to reorder vertically');
          break;
        case 'move':
          setCurrentIcon(Move);
          setCurrentTitle('Drag to reorder');
          break;
      }
      return;
    }

    // Auto mode: responsive based on screen size
    const updateIcon = () => {
      const width = window.innerWidth;
      // Since pinned apps are now always single column (removed 2xl:grid-cols-4),
      // always use vertical movement for consistency
      setCurrentIcon(MoveVertical);
      setCurrentTitle('Drag to reorder vertically');
    };

    // Initial check
    updateIcon();

    // Listen for resize events
    window.addEventListener('resize', updateIcon);
    
    return () => {
      window.removeEventListener('resize', updateIcon);
    };
  }, [iconType]);

  return { icon: currentIcon, title: currentTitle };
}; 